import React, {useState, useEffect} from 'react'
import {Route, Routes, BrowserRouter} from 'react-router';
import './App.css';
import './components/Landing/Landing.css'
import {service} from './config/app'
import Synchronize from './apps/Synchronize/Synchronize';
import {Site} from './apps/Synchronize/site/Site';
import {Drive} from './apps/Synchronize/drive/Drive';
import {Worker} from './apps/Synchronize/worker/Worker';
import {Detail} from './apps/Synchronize/detail/Detail';
import {Step} from './apps/Synchronize/step/Step';
import Header from './components/Landing/Header';
import Global from './components/Shared/Global';
import Landing from './components/Landing/Landing';
import {ProfileView} from './components/Profile/Profile';
import Plans from './components/Plan/Plans'
import Quote from './components/Invoicing/Quote';
import Invoice from './components/Invoicing/Invoice';
import Api, {Read} from './components/Shared/Api';
import Subscriptions from './components/Admin/Subscribers' ;
import Footer from './components/Landing/Footer';

// ocr -> tech
import {Digitization} from './apps/Digitization/Digitization' ;
import {Settings} from './components/Setting/Settings' ;

// log -> note
import {Note} from './apps/Logger/Note' ; 
import {Planner} from './apps/Planner/Planner' ; 
import Home from './components/Home/Home' ;

import {ProfileMain} from './components/Profile/Profile';
import SignModal from './components/sign/SignModal';


function App() {

  const global = new Global()

  const [account, Account] = useState({Service: service.name, connected:false, message:'Ready', name:'', email:'',role:0, id:0, Session:0, API_KEY:''})
  const [search, Search]  = useState("")
  const [plan, Plan] = useState("Extend")
  const [etat, Etat] = useState("")
  const [lang, Lang] = useState("en")
  const [items, Items]= useState([])
  const [showing, Showing] = useState(false)

  useEffect(() => {
    //  alert("Api : "+JSON.stringify(account))
    const store = localStorage.getItem(service.name)
    if(store) {
        const stored = JSON.parse(store)

        Account({...account, ...stored})
        
        Read(`/account/Profile/${account.id}`, Items)
    }
  },[])

  const getProfile = (key) => {
    return items.find(item => item.Key === key)?.Value
  }
  
  useEffect(()=>{ 
    if(items?.length>0) {
      //alert(JSON.stringify(account))    
      //console.log(items); alert(items.length)   
      Account({...account, 
        id:getProfile('Id'),
        name:getProfile('Name'),
        email:getProfile('Email'),
        role:getProfile('Role')
      })
    }
  },[items])

  useEffect(()=>{ 
    if(plan) {       
      //alert(plan)
    }
  },[plan])


return (

  <BrowserRouter>
    <Header lang={lang} onLang={Lang} account={account} service={service} onAccount={Account} />
    { account?.connected ?
      <Routes>    
        <Route path='/' element={ <Landing lang={lang} account={account} onPlan={Plan} />} exact />

        <Route path='/sync' element={ <Synchronize lang={lang} account={account} onEtat={Etat} />}  />
        <Route path='/site' element={ <Site lang={lang} global={global} account={account} onEtat={Etat} />} />
        <Route path='/drive' element={ <Drive lang={lang} global={global} account={account} onEtat={Etat} />} />
        <Route path='/worker' element={ <Worker lang={lang} global={global} account={account} onEtat={Etat} />} />
        <Route path='/detail' element={ <Detail lang={lang} global={global} account={account} onEtat={Etat}/>} />
        <Route path='/step' element={ <Step lang={lang} global={global} account={account} onEtat={Etat} />} />

        <Route path='/profile' element={ <ProfileView lang={lang} account={account} />} />
        <Route path='/quote' element={ <Quote lang={lang} plan={plan} account={account} />} /> 
        <Route path='/invoice' element={ <Invoice lang={lang} plan={plan} account={account} />} /> 
        <Route path='/admin' element={ <Subscriptions lang={lang} account={account} /> } />

        <Route path='/ocr' element={ <Digitization lang={lang} account={account} search={search} />} />
        <Route path='/setting' element={ <Settings lang={lang} account={account} />} /> 

        <Route path='/note' element={ <Note global={global} lang={lang} account={account} search={search} />} />
        <Route path='/planner' element={ <Planner account={account} search={search} />} />
        
        <Route path='/home' element={ <Home lang={lang} account={account} />} exact />
      </Routes>
  :  
    <Routes>    
      <Route path='/' element={ <Home lang={lang} />} exact />
    </Routes>    
  }

<ProfileMain lang={lang} service={service} account={account} Login={()=>Showing(true)}/>

{ showing && <SignModal 
    service={service.name}
    show={showing}
    logo={'images/sync-2.png'}
    onHide={()=>Showing(false)}
/> }


  <Footer lang={lang} etat={etat + " " + account?.message} />

</BrowserRouter>

  )
}

export default App;
